import { UploadPresignInfo } from './upload'

export enum FileTypeEnum {
  Excel = 'excel',
  All = 'all', // 小程序那边传这个可以选择上传任何文件
  Image = 'image',
  Video = 'video',
  Audio = 'audio',
}

export interface IFileTypeInfo {
  type: FileTypeEnum
  name: string
  accept: string
}

export interface IFileUploadParams {
  file: File
  scene?: string
  filename?: string
  forceShowLoading?: boolean
  presignAPI?: (scene: string, filename: string) => Promise<UploadPresignInfo>
  onUploadProgress?: (progressEvent: ProgressEvent) => void
}
